












































import { Vue, Component, Prop, Watch } from "vue-property-decorator";


@Component({
  components: {

  }
})
export default class AppMenu extends Vue {

  get miniOpen() {
    return this.$store.state.appMenuMini;
  }

  menuIcon() {
    return this.miniOpen ? 'navigate_next' : 'navigate_before';
  }

  card(cardName) {
    return this.$store.getters.getCard(cardName);
  }

  closeAllCardsButOne(cardName) {
    this.$store.commit('closeCardsButOne', this.card(cardName));

    setTimeout(() => {
      this.$vuetify.goTo('#' + cardName, { offset: -75 });
    }, 400);
  }

  show: boolean = true;

  drawer = true;
  mini = true;
  items = [
    { title: 'Notes',     cardName:'NotesCard',    type:"icon",   icon: 'edit' },
    { title: 'Box',       cardName:'BoxCard',      type:"avatar", icon: '/static/box_3_SCA_icon.png' },
    { title: 'Boards',    cardName:'BoardsCard',   type:"avatar", icon: '/static/double_board_2_SCA_icon.png' },
    { title: 'Graphs',    cardName:'GraphsCard',   type:"icon",   icon: 'equalizer' }
  ];
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppMenu.vue